import { Component, OnInit, Input, EventEmitter, Output, ElementRef, Injector, ApplicationRef, ComponentFactoryResolver} from '@angular/core';
import { SwSeatConfigBoxComponent } from './sw-seat-config-box/sw-seat-config-box.component';
declare var $: any;
@Component({
  selector: 'sw-seat-selection',
  templateUrl: './sw-seat-selection.component.html',
  styleUrls: ['./sw-seat-selection.component.css']
})
export class SwSeatSelectionComponent implements OnInit {

//座位分区配置
//例如： [{id:'1',name:'vip区',price:50,discount:30,color:'#FACD91'},]
@Input() seatConfig:any = [
  // {id:'1',name:'vip区',price:50,discount:30,color:'#FACD91'},
  // {id:'2',name:'普通区',price:50,discount:30,color:'#02A7F0'},
]
// 例如：[{ id:'1_3',rowId:1,colId:3,config:{typeId:'2',color:'#02A7F0',isDiscount:false},isSold:false,isLock:false}]
@Input() allSeatsList:any = []//座位数据重新渲染  包含id  config  rowId  colId isSold =>行过道不占行id值，纵过道不占纵id值
// selectedSeats:any = [] ;//点击座位，选择的座位数组 （页面点击的座位）
@Input() clickType:any = 'editConfig' ;//点击类型：1.radio 单选（一次只能选一张票） 2.checkbox 多选（一次可多选票） 3.retain 保留座位（保留座位操作） 4.unClick 不可点击，只看状态  5.editConfig 可编辑座位的每个配置信息事件

//radio 
@Input() radioSelectedId:any = '' ;//clickType类型为radio   单选选票时，已选择的数据
radioSelected:any ={} //clickType类型为radio   单选选票时，选择的数据
@Output() outRadioSelected = new EventEmitter();  //抛出事件，抛出单选选票时，选择的数据

//checkbox
checkboxSelected:any =[] //clickType类型为checkbox   多选选票时，选择的数据
@Output() outCheckboxSelected = new EventEmitter(); //抛出事件，抛出多选选票时，选择的数据
@Output() outDeleteSelected = new EventEmitter(); //抛出事件，抛出当前取消的数据

//retain
@Input() retainSelected:any =[] //clickType类型为retain   选择保留座位时，选择的数据
@Output() outRetainSelected = new EventEmitter(); //抛出事件，抛出保留座位时，选择的数据

//editConfig
@Output() outConfigSelected = new EventEmitter(); //抛出事件，抛出编辑座位时，选择的数据

@Input() configHeight: string = '150px';  //座位配置的高度
ids:any
//点击座位时，对应数组的下标
listIndex:number=0 // 数据allSeatsList的下标，表示选中的对应的行
seatIndex:number = 0 //数据allSeatsList[]['datas']的下标，表示选中的对应的列
 //舞台left值
 screenLeft:any = ''
 @Input() height: string = 'auto';  //选座组件的高度
 @Input() screenTitle: string = '舞台方向';  //舞台标题
  constructor(
    private el :ElementRef,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) { }

  ngOnInit() {
    this.ids = "seat" + Math.random().toString().split(".")[1];
  }
  ngAfterViewInit(): void {
    //获取座位的宽、高、坐标位置=》进而设置舞台方向坐标
    let interval = setInterval(()=>{
      if(document.getElementById('seatsWrapper')){
        let position = document.getElementById('seatsWrapper').getBoundingClientRect()
        if(position.width > 650){
          let left = Math.round((position.width - 650)/2) + 9
          this.screenLeft = left + 'px'
          $("#screenContainer").css('left',this.screenLeft)
          clearInterval(interval)
        }
      }
    },20)
   
    //监听右侧座位滚动事件
    var right_div = document.getElementById("seatsContainer");
       right_div.onscroll = ()=>{
          var right_div_top = right_div.scrollTop;
          document.getElementById("rowIdContainer").scrollTop = right_div_top;
     }

    
  }


//单选选票
clickRadioSeat(seat) {
  //排除空列和过道 且 排除 已售出的 和 已锁定座位的 =>即可以点击的座位
  if(seat.colId != 'f' && seat.colId != 'k' && !(seat.sold || seat.retain || seat.lock)){
      //单选选票
      if(this.clickType == 'radio'){
        this.radioSelected = seat
        this.radioSelectedId = seat.id
        // $('.seat').removeClass('active')
        // $('#'+seat.id).addClass('active')
        this.outRadioSelected.emit(this.radioSelected)
      }
    }
}

//多选选票
clickCheckboxSeat(seat) {
  //排除空列和过道 且 排除 已售出的 和 已锁定座位的 =>即可以点击的座位
  if(seat.colId != 'f' && seat.colId != 'k' && !(seat.sold || seat.retain || seat.lock)){
       //多选选票
    if(this.clickType == 'checkbox'){
      let dels = []
      let index = this.checkboxSelected.findIndex(val=>val.id == seat.id)
      if(index == -1){
       this.checkboxSelected.push(seat)
       $('#'+seat.id).addClass('active')
      }else {
       this.checkboxSelected.splice(index,1)
       $('#'+seat.id).removeClass('active')
      }
      this.outDeleteSelected.emit(dels)
      this.outCheckboxSelected.emit(this.checkboxSelected)
     } 
   }
}
isChecked(id){
  return this.checkboxSelected.findIndex(value => value,id == id) >= 0;
}
//保留座位选票
clickRetainSeat(seat) {
  //排除空列和过道 且 排除 已售出的座位 =>即可以点击的座位
  if(seat.colId != 'f' && seat.colId != 'k' && !(seat.sold || seat.lock)){
     //锁定座位选票
    if(this.clickType == 'retain'){
      //retainSelected:   
      let index = this.retainSelected.findIndex(val=>val.id == seat.id)
      if(index == -1){
       this.retainSelected.push(seat)
       let ispan = "<i style='position: absolute;font-size: 12px;top: 4px;left: 9px;color: #fff;'>留</i>"
       $('#'+seat.id).append(ispan)
       $('#'+seat.id).addClass('retainActive')
      }else {
       this.retainSelected.splice(index,1)
       $('#'+seat.id).find('i').remove()
       $('#'+seat.id).removeClass('retainActive')
      }
       this.outRetainSelected.emit(this.retainSelected)
    }
   }
}

//编辑每个座位信息配置事件 editConfig 
clickSeatConfig(seat,listIndex,seatIndex) {
  this.listIndex = listIndex
  this.seatIndex = seatIndex
  //排除空列和过道
  if(seat.colId != 'f' && seat.colId != 'k'){
    //可编辑座位的每个配置信息事件 =》配置该座位为什么类型座位 =》如vip区 或 普通区 座位，根据配置来设定
    if(this.clickType == 'editConfig'){
        this.open(event,seat)
     }
    }
 
   }
   dropdown:boolean = false
   /**
   *  @ignore
   *  展现关闭下拉
   */
  swSelectMultiComponentRef:any;
  /**
   * 打开下拉框
   * @ignore
   */
  open(event,seat){ 
    if($('swseatconfigboxcomponent')){
      $('body').find('swseatconfigboxcomponent').remove();
    }

    const com = document.createElement(SwSeatConfigBoxComponent.name);
    //创建动态组件
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwSeatConfigBoxComponent);
    this.swSelectMultiComponentRef = factory.create(this.injector, [], com);
    this.applicationRef.attachView(this.swSelectMultiComponentRef.hostView);
    // 打开下拉框
    this.dropdown = true; 
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["ids"] = this.ids;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["elemId"] = seat.id;
    // 向动态创建的组件传递参数
    this.swSelectMultiComponentRef.instance["selected"] = seat.config.typeId;
   
    this.swSelectMultiComponentRef.instance["seatConfig"] = this.seatConfig;

    this.swSelectMultiComponentRef.instance["configHeight"] = this.configHeight;
    // 向动态创建的组件传递回调函数
    this.swSelectMultiComponentRef.instance["closeSelect"].subscribe(data => {
      try {
        this.dropdown = false
        // 失去焦点
       // this.input.nativeElement.blur()
        // 移除元素
        document.body.removeChild(com);
        this.applicationRef.detachView(this.swSelectMultiComponentRef.hostView);
        // 销毁组件
        this.swSelectMultiComponentRef.destroy()
      } catch (e) { }

    });

    this.swSelectMultiComponentRef.instance["changeClick"].subscribe(data => {
      try {
        // 有参数就触发此事件 抛出选择的参数对象
        this.updateConfig(data)
      } catch (e) { }

    });
    // 将组件加到dom中去显示
    document.body.appendChild(com);
    
  }
 //更新对应数组的参数值 ==>以后扩展框选功能时，要修改
 updateConfig(config){
  let seatConfig = config
  let seat = this.allSeatsList[this.listIndex]['datas'][this.seatIndex]
  let objIds = [seat.seatInitializeId]
  let  params = {
    str:seatConfig.seatPartitionId, //配置id
    objIds:objIds      //座位id数组
  }
  this.outConfigSelected.emit(params)
  //前端先修改样式背景=》减少请求次数
   this.allSeatsList[this.listIndex]['datas'][this.seatIndex]['config']['typeId'] = config.id
   this.allSeatsList[this.listIndex]['datas'][this.seatIndex]['config']['color'] = config.color

 }
  /**
   * 关闭下拉框
   * @ignore
   */
  close() {
    // this.dropdown = false; 
    this.swSelectMultiComponentRef.instance.close()
  }
}
